module.exports = __webpack_public_path__ + "img/1467411623.2fcd9a35.jpg";